// extracted by mini-css-extract-plugin
export default {"deleteText":"banner-preview_deleteText__kpjNI"};